import styles from "./videomeetsetting.module.scss";
import React, {useEffect, useState } from 'react';
import { Divider, Switch} from "antd";
import { URButton } from "../../../../shared/widgets/button";
import { useSelector } from "react-redux";
import { profileDetails } from "../../../../models/model";
import { saveVideoSetting } from "../../../../base/eventService/eventApiService";

type videoSettingState ={
  wating_room: boolean,
  passcode_participants: boolean,
  passcode_invite_link: boolean,
  personal_meeting_id: boolean,
  host_video: boolean,
  participants_video: boolean,
  allow_partiipants_before_host: boolean,
  enable_personal_meeting_id: boolean,
  schedule_personal_meeting_id: boolean,
  instant_personal_meeting_id: boolean,
  mute_all_participants: boolean,
  meeting_chat: boolean,
  sound_notification: boolean,
  screen_share: boolean,
  allow_removed_participants_to_rejoin: boolean,
  allow_participants_to_rename_themselves: boolean,
  full_transcript: boolean,
  virtual_background: boolean,
  request_permission_to_mute: boolean,
  passcode: any;
  
}
export default function VideoMeetSetting() {
  //const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  let { videoprofileData }: profileDetails = useSelector((state: any) => state.profileReducer);
  let pass:any = videoprofileData?.security?.passcode !== ""?true: false
  const [togglePass, setTogglePass] = useState<boolean>(false);
    const [passwordView, SetpasswordView] = useState<boolean>(pass);
  const [EditView, SetEditView] = useState<boolean>(false);
  const [videoSetting, setvideoMeetSetting] = useState<videoSettingState>({
    wating_room: false,
    passcode_participants: false,
    passcode_invite_link: false,
    personal_meeting_id: false,
    host_video: true,
    participants_video: true,
    allow_partiipants_before_host: false,
    enable_personal_meeting_id: false,
    schedule_personal_meeting_id: false,
    instant_personal_meeting_id: false,
    mute_all_participants: false,
    meeting_chat: false,
    sound_notification: false,
    screen_share: false,
    allow_removed_participants_to_rejoin: false,
    allow_participants_to_rename_themselves: false,
    full_transcript: false,
    virtual_background: false,
    request_permission_to_mute: false,
    passcode:""
    
  });
  useEffect(() => {
    setvideoMeetSetting({...videoSetting,
      wating_room: videoprofileData.security.wating_room,
    passcode_participants: videoprofileData.security.passcode_participants,
    passcode_invite_link: videoprofileData.security.passcode_invite_link,
    personal_meeting_id: videoprofileData.security.personal_meeting_id,
    host_video: videoprofileData.schedule.host_video,
    participants_video: videoprofileData.schedule.participants_video,
    allow_partiipants_before_host: videoprofileData.schedule.allow_partiipants_before_host,
    enable_personal_meeting_id: videoprofileData.schedule.enable_personal_meeting_id,
    schedule_personal_meeting_id: videoprofileData.schedule.schedule_personal_meeting_id,
    instant_personal_meeting_id: videoprofileData.schedule.instant_personal_meeting_id,
    mute_all_participants: videoprofileData.schedule.mute_all_participants,
    meeting_chat: videoprofileData.in_meeting_basics.meeting_chat,
    sound_notification: videoprofileData.in_meeting_basics.sound_notification,
    screen_share: videoprofileData.in_meeting_basics.screen_share,
    allow_removed_participants_to_rejoin: videoprofileData.in_meeting_basics.allow_removed_participants_to_rejoin,
    allow_participants_to_rename_themselves: videoprofileData.in_meeting_basics.allow_participants_to_rename_themselves,
    full_transcript: videoprofileData.in_meeting_advance.full_transcript,
    virtual_background: videoprofileData.in_meeting_advance.virtual_background,
    request_permission_to_mute: videoprofileData.in_meeting_advance.request_permission_to_mute,
    passcode:videoprofileData.security.passcode
    });
    
}, [videoprofileData])

  const videoMeetSetting = (name:any,value:any) =>{
    setvideoMeetSetting({...videoSetting,[name]:value});
    let videoRes:any = videoSetting
    videoRes[name] = value;
    saveVideoSetting(videoRes);
   }

  const SetNewPassword = (e: any) => {
    setvideoMeetSetting({...videoSetting, passcode: e.target.value});
  };

  const togglePassword = () => {
    setTogglePass(!togglePass);
  };
  const savePasscode = ()=>{
    saveVideoSetting(videoSetting);
    SetpasswordView(true)
    SetEditView(false)
  }

  const Edit = ()=>{
    SetEditView(true)
  }
  const cancel = ()=>{
    setvideoMeetSetting({...videoSetting, passcode: ""});
  }

  return (
    <>
      <div className={styles.mainInnerConSec}>
        <div className={styles.userprofileformConvideomeet}>
          <div className={`${styles.formGroup} `}>
            <div className={styles.topheadertext}>
                <h4>
                  Security  
                </h4>
            </div>
            <div className={styles.settingsBox}>
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Waiting Room</h4>
                    <p>
                    When participants join a meeting, place them in a waiting room and require the host to admit them individually. 
                    Enabling the waiting room automatically disables the setting for allowing participants to join before host.
                    </p>
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch  onChange={(e: any) => videoMeetSetting('wating_room', e)} checked={videoSetting.wating_room}/>
                  </div>
                </div>
              </div>
              <Divider />
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Require passcode for participants joining by phone</h4>
                    <p>
                    A numeric passcode will be required for participants joining by phone if your meeting has a passcode. For meeting with an alphanumeric passcode, a numeric version will be generated.

                    </p>
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('passcode_participants', e)} checked={videoSetting.passcode_participants}/>
                  </div>
                </div>
              </div>
              <Divider />
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Embed passcode in invite link for one-click join</h4>
                    <p>
                    Meeting passcode will be encrypted and included in the invite link to allow participants to join with just one click without having to enter the passcode.

                    </p>
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('passcode_invite_link', e)} checked={videoSetting.passcode_invite_link}/>
                  </div>
                </div>
              </div>
              <Divider />
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Personal Meeting ID (PMI) Passcode</h4>
                    <p>
                    All Personal Meeting ID (PMI) meetings that users can join via client, or room systems will be passcode-protected.
                    </p>
                    {(videoSetting.personal_meeting_id === true && videoSetting.passcode==="")
                    || (passwordView===false &&videoSetting.personal_meeting_id === true) || 
                    (videoSetting.personal_meeting_id === true &&EditView===true)?  <div className={`${styles.rowFlex} ${styles.leftinputbox}`}>
                      {/* <label className={`${styles.three} ${styles.colformLabel}`}>Emergency Address</label> */}

                      <div className={styles.addressInput}>
                        <input type="text" className={styles.formControl}   maxLength={6}                       
                          placeholder="Enter passcode" onChange={SetNewPassword} value={videoSetting.passcode}/>
                      </div>
                      
                      <div className={styles.rihgtsecbtn}>
                    <URButton className='urButton buttonGray buttonSm' name='Save' onClick={savePasscode} disabled={videoSetting.passcode==="" ? true :false }/>
                        <URButton className='urButton buttonWhite buttonSm' name='Cancel'  onClick={cancel}/>
                      </div>

                      </div>
                        :
                        videoSetting.personal_meeting_id && passwordView===true && <div className={!togglePass ?
                          `${styles.passwordArea}` : `${styles.passwordShowArea}` }>
                          <label className={styles.colformLabel}>Passcode:</label>
                            <span className={styles.passText}>{videoSetting.passcode}</span>
                            <span className={togglePass? `${styles.active} ${styles.hidetxtblue}`  
                            :  `${styles.active} ${styles.hidetxtblue}` } onClick={togglePassword}> {togglePass? 'Hide' : 'Show'} </span> 
                            
                            <span className={styles.hidetxtblue} onClick={Edit} >Edit</span>
                          </div>
                          }
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('personal_meeting_id', e)} checked={videoSetting.personal_meeting_id}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.formGroup} `}>
            <div className={styles.topheadertext}>
                <h4>
                Schedule Meeting
                </h4>
            </div>
            <div className={styles.settingsBox}>
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Host Video</h4>
                    <p>
                    Start meetings with host video on
                    </p>
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('host_video', e)} checked={videoSetting.host_video}/>
                  </div>
                </div>
              </div>
              <Divider />
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Participants Video</h4>
                    <p>
                    Start meetings with participant video on. Participants can change this during the meeting.
                    </p>
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('participants_video', e)} checked={videoSetting.participants_video} />
                  </div>
                </div>
              </div>
              <Divider />
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Allow participants to join before host</h4>
                    <p>
                    Allow participants to join the meeting before the host arrives
                    </p>
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('allow_partiipants_before_host', e)} checked={videoSetting.allow_partiipants_before_host}/>
                  </div>
                </div>
              </div>
              <Divider />
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Enable Personal Meeting ID</h4>
                    <p>
                    A Personal Meeting ID (PMI) is a 9 to 11 digit number that is assigned to your account.
                    </p>
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('enable_personal_meeting_id', e)} checked={videoSetting.enable_personal_meeting_id}/>
                  </div>
                </div>
              </div>
              <Divider />
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Use Personal Meeting ID (PMI) when scheduling a meeting</h4>
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('schedule_personal_meeting_id', e)} checked={videoSetting.schedule_personal_meeting_id}/>
                  </div>
                </div>
              </div>
              <Divider />
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Use Personal Meeting ID (PMI) when starting an instant meeting</h4>
                  
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('instant_personal_meeting_id', e)} checked={videoSetting.instant_personal_meeting_id}/>
                  </div>
                </div>
              </div>
              <Divider />
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Mute all participants when they join a meeting</h4>
                    <p>
                    Automatically mute all participants when they join the meeting. The host controls whether participants can unmute themselves.
                    </p>
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('mute_all_participants', e)} checked={videoSetting.mute_all_participants}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`${styles.formGroup} `}>
            <div className={styles.topheadertext}>
                <h4>
                In Meeting (Basics)
                </h4>
            </div>
            <div className={styles.settingsBox}>
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Meeting chat</h4>
                    <p>
                    Allow meeting participants to send chat messages
                    </p>
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('meeting_chat', e)} checked={videoSetting.meeting_chat}/>
                  </div>
                </div>
              </div>
              <Divider />
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Sound notification when someone joins or leaves</h4>
                    
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('sound_notification', e)} checked={videoSetting.sound_notification}/>
                  </div>
                </div>
              </div>
              <Divider />
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Screen sharing </h4>
                    <p>
                    Allow host and participants to share their screen or content during meetings.
                    </p>
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('screen_share', e)} checked={videoSetting.screen_share}/>
                  </div>
                </div>
              </div>
              <Divider />
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Allow removed participants to rejoin</h4>
                    <p>
                    Allow previously removed meeting participants to rejoin
                    </p>
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('allow_removed_participants_to_rejoin', e)} checked={videoSetting.allow_removed_participants_to_rejoin}/>
                  </div>
                </div>
              </div>
              <Divider />
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
              <div className={styles.leftconsectmain}>
                  <h4>Allow participants to rename themselves</h4>
                  <p>
                  Allow meeting participants to rename themselves.
                  </p>
              </div>
              <div>
                  <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                    <Switch onChange={(e: any) => videoMeetSetting('allow_participants_to_rename_themselves', e)} checked={videoSetting.allow_participants_to_rename_themselves}/>
                </div>
              </div>
              </div>
            </div>
          </div>
          <div className={`${styles.formGroup} `}>
            <div className={styles.topheadertext}>
                <h4>
                In Meeting (Advanced)
                </h4>
            </div>
            <div className={styles.settingsBox}>
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Full transcript </h4>
                    <p>
                    Allow viewing of full transcript in the in-meeting side panel
                    </p>
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('full_transcript', e)} checked={videoSetting.full_transcript}/>
                  </div>
                </div>
              </div>
              <Divider />
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Virtual background</h4>
                    <p>
                    Customize your background to keep your environment private from others in a meeting. This can be used with or without a green screen.
                    </p>
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('virtual_background', e)} checked={videoSetting.virtual_background}/>
                  </div>
                </div>
              </div>
              <Divider />
              <div className={`${styles.rowFlex} ${styles.meetcontohead}`}>
                <div className={styles.leftconsectmain}>
                    <h4>Request permission to unmute </h4>
                    <p>
                    Select this option in the scheduler to request permission to unmute meeting participants .Permissions, once given, will apply in all meetings scheduled by the same person.
                    </p>
                </div>
                <div>
                    <div className={`customsizeswittogle ${styles.switchtogglebtn}`}>
                      <Switch onChange={(e: any) => videoMeetSetting('request_permission_to_mute', e)} checked={videoSetting.request_permission_to_mute}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};
